<template>
    <div class="chat_row">
        <dialogBox
                v-if="chatItem.type === 'sayText' || chatItem.type === 'sayImg' || chatItem.type === 'sayOther' || chatItem.type === 'sayHealthRecords' || chatItem.type == 'sayVoice'"
                v-bind:chatItem="chatItem" v-bind:userId="userId"></dialogBox>
        <interactionBox v-else v-bind:chatItem="chatItem" v-bind:userId="userId"></interactionBox>
    </div>
</template>
<style scoped>
    .chat_row {
        padding: 5px 1rem;
        display: inline-block;
        width: 98%;
    }
</style>
<script>
    import dialogBox from "./dialogBox";
    import interactionBox from "./interactionBox";

    export default {
        props: {
            chatItem: {type: Object},
            userId: {type: String}
        },
        components: {
            dialogBox, interactionBox
        },
        mounted() {

        }
    };
</script>